import {Box, Checkbox, Stack, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import {loadCartFromLocalStorage} from "../../utils/cart";
import Avatar from "@mui/material/Avatar";
import {thousandSeparator} from "../../utils/Utils";

const Summary = ({accept, setAccept, data}) => {
    const theme = useTheme()
    let orderedProducts = loadCartFromLocalStorage();
    const calculateOrderTotal = () => {
        return orderedProducts.reduce((acc, curr) => acc + (curr?.price * curr?.quantity), 0)
    }
    return <Stack justifyContent='center' alignItems='center' spacing={2}>
        <Typography variant='headline2' color='primary.main'>Összefoglaló</Typography>
        <div className="success-container-data">
            <Stack>
                <Typography variant="headline6" align="center" color='primary.main'>Személyes adatok</Typography>
                <table style={{marginBottom: '20px'}}>
                    <tbody>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Név</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.last_name} {data?.first_name}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Email</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.email}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Telefon</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.phone}
                            </Typography>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <Typography variant="headline6" align="center" color='primary.main'>Számlázási
                    adatok</Typography>
                <table style={{marginBottom: '20px'}}>
                    <tbody>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Név</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.billing_name}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Cím</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.billing_country} {data?.billing_postal_code}, {data?.billing_city} {data?.billing_address}
                            </Typography>
                        </td>
                    </tr>
                    <tr>
                        <td><Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Adószám</Typography></td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {data?.billing_vat_number || '-'}
                            </Typography>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <Typography variant="headline6" align="center" color='primary.main'>Rendelt
                    termékek</Typography>
                <table style={{marginBottom: '20px'}}>
                    <tbody>
                    {orderedProducts?.map(product => (
                        <tr key={product?.id}>
                            <td>
                                <Avatar src={product?.image}/>
                            </td>
                            <td>
                                <Typography variant="body1" color='primary.main'>
                                    {product?.name || '-'}
                                </Typography>
                            </td>
                            <td>
                                <Typography variant="body1" color='primary.main' align="right">
                                    {thousandSeparator(product?.price)} Ft ({product?.quantity} db)
                                </Typography>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={2}>
                            <Typography variant="body2" color='#1C2427' style={{fontWeight: '700'}}>Összesen</Typography>
                        </td>
                        <td>
                            <Typography variant="body1" color='primary.main' align="right">
                                {thousandSeparator(calculateOrderTotal())} Ft
                            </Typography>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Stack>
        </div>

        <FormControlLabel
            control={<Checkbox checked={accept} onChange={(e) => setAccept(e.target.checked)}/>}
            label={<Typography variant='caption'>
                Elfogadom az
                <a style={{color: theme.palette.primary[700]}} target='_blank'
                   href='https://dinobooking.hu/adatvedelem' rel="noreferrer">
                    adatvédelmi nyilatkozatot
                </a> és amennyiben online fizetek a
                <a style={{color: theme.palette.primary[700]}} href="/adattovabbitasi-nyilatkozat"
                   target='_blank'>
                    SimplePay adattovábbítási nyilatkozatot
                </a>
            </Typography>} style={{color: '#6F8E9A'}}/>
    </Stack>
}

export default Summary;